console.log('CRAP.SUPPLY Filename Switcher loaded');

(function() {
  'use strict';

  // --- CONFIGURATION ---
  const CABLE_KEYWORD = 'SYNC';
  const ALWAYS_SHOW_PREFIX = 'ALL-';
  const MEDIA_POSTER_PATH = '/PREVIEW_IMAGES/';
  const CHECKBOX_WAIT_RETRIES = 5;   // x 500ms before starting without the cable checkbox
  const LATE_CHECKBOX_POLLS   = 60;  // x 500ms of watching for it to show up afterwards

  const productConfig = {
    'screenmount-for-samsung': {
      variantFieldName: 'SSD TYPE',
      variants: {
        'T7 SHIELD': { filenamePart: 'T7SHIELD' },
        'T9':        { filenamePart: 'T9' },
        'T7':        { filenamePart: 'SAMSUNG-T7', exclude: 'SHIELD' },
        'P9':        { filenamePart: 'SAMSUNG-P9' },
        'P7':        { filenamePart: 'SAMSUNG-P7' }
      }
    },
    'screenmount-for-sandisk': {
      variantFieldName: 'SSD TYPE',
      variants: {
        'EXTREME PRO':       { filenamePart: 'SANDISK-X-PRO', exclude: 'XPRO' },
        'EXTREME':  { filenamePart: ['SANDISK-X', 'SANDISK-X-3D'], exclude: 'PRO' },
        'PORTABLE':          { filenamePart: 'SANDISK-P' }
      }
    },
    'universal-screenmount': {
      variantFieldName: null,
      variants: {
        'UNIVERSAL': { filenamePart: 'UNIVERSAL' }
      }
    }
  };

  function findCableCheckbox() {
    return document.querySelector('input[type="checkbox"][data-gtm-form-interact-field-id="4"]')
        || document.querySelector('input[type="checkbox"][aria-labelledby*="usb-c-cable"]')
        || document.querySelector('input[type="checkbox"][aria-labelledby*="cable"]');
  }

  function initImageSwitcher() {
    let productHandle = window.location.pathname.split('/products/')[1];
    if (productHandle) productHandle = productHandle.split('?')[0].split('#')[0];

    const config = productConfig[productHandle];
    if (!config) return;

    let checkbox = findCableCheckbox();

    const mainGallery = document.querySelector('.js-media-list');
    const subGallery  = document.querySelector('.js-media-sublist');

    // The gallery is required. The cable checkbox is not: the upsell app doesn't render it
    // when the cable is already in the cart, so only wait a short while for it.
    if (!window.initRetryCount) window.initRetryCount = 0;
    const galleryReady       = mainGallery && mainGallery.swiper;
    const waitingForCheckbox = !checkbox && window.initRetryCount < CHECKBOX_WAIT_RETRIES;

    if (!galleryReady || waitingForCheckbox) {
      if (window.initRetryCount < 10) {
        window.initRetryCount++;
        setTimeout(initImageSwitcher, 500);
      }
      return;
    }

    const swiper    = mainGallery.swiper;
    const subSwiper = subGallery && subGallery.swiper ? subGallery.swiper : null;

    // Cache original slide HTML once
    const mainOriginalSlides = Array.from(swiper.slides).map(s => s.outerHTML);
    const subOriginalSlides  = subSwiper
      ? Array.from(subSwiper.slides).map(s => s.outerHTML)
      : [];

    function shouldShowSlide(slideEl, variantConfig, wantCable) {
      // Try to find a filename from ANY media type in the slide:
      // <img>, <model-viewer>, <source>, <video>, or data attributes.
      let src = '';

      const img    = slideEl.querySelector('img');
      const model  = slideEl.querySelector('model-viewer, [src*=".glb"], [data-src*=".glb"]');
      const source = slideEl.querySelector('source');
      const video  = slideEl.querySelector('video');

      if (img) {
        src = img.getAttribute('src') || img.getAttribute('data-src') || '';
      } else if (model) {
        src = model.getAttribute('src') || model.getAttribute('data-src') || '';
      } else if (source) {
        src = source.getAttribute('src') || source.getAttribute('data-src') || '';
      } else if (video) {
        src = video.getAttribute('src') || video.getAttribute('data-src') || '';
      }

      // Fallback: scan the whole slide's HTML for the filename if nothing found above.
      if (!src) {
        src = slideEl.innerHTML;
      }

      src = src.toUpperCase();

      // If we genuinely found no usable name, default to showing it.
      if (!src) return true;

      // ALL- prefix means always show
      if (src.indexOf(ALWAYS_SHOW_PREFIX) > -1) return true;

      // filenamePart can be a single string or a list of accepted spellings
      const searchParts = [].concat(variantConfig.filenamePart).map(p => p.toUpperCase());
      const excludePart = variantConfig.exclude ? variantConfig.exclude.toUpperCase() : null;

      const matchesVariant    = searchParts.some(p => src.indexOf(p) > -1);
      const isExcluded        = excludePart && src.indexOf(excludePart) > -1;
      const hasCableKeyword   = src.indexOf(CABLE_KEYWORD) > -1;

      // 3D models and videos aren't cable-specific (Shopify serves their posters
      // from /preview_images/), so they stay visible when the cable is checked.
      const isModelOrVideo    = src.indexOf(MEDIA_POSTER_PATH) > -1;
      const matchesCableState = wantCable ? (hasCableKeyword || isModelOrVideo) : !hasCableKeyword;

      return matchesVariant && !isExcluded && matchesCableState;
    }

    function getFilteredHTML(originalSlidesHTML, variantConfig, wantCable) {
      const result = [];
      const tempContainer = document.createElement('div');

      for (let i = 0; i < originalSlidesHTML.length; i++) {
        tempContainer.innerHTML = originalSlidesHTML[i];
        const slideEl = tempContainer.firstElementChild;
        if (slideEl && shouldShowSlide(slideEl, variantConfig, wantCable)) {
          result.push(originalSlidesHTML[i]);
        }
      }
      return result;
    }

    function rebuildSwiper(targetSwiper, originalSlidesHTML, variantConfig, wantCable) {
      if (!targetSwiper) return;

      const filteredHTML = getFilteredHTML(originalSlidesHTML, variantConfig, wantCable);

      targetSwiper.removeAllSlides();

      if (filteredHTML.length > 0) {
        targetSwiper.appendSlide(filteredHTML);
      }

      targetSwiper.update();
      targetSwiper.slideTo(0, 0);
    }

    function getSelectedVariantConfig() {
      if (!config.variantFieldName) return Object.values(config.variants)[0];
      const checkedRadio = document.querySelector('input[name="' + config.variantFieldName + '"]:checked');
      const val = checkedRadio ? checkedRadio.value : '';
      return config.variants[val];
    }

    function updateGallery() {
      const variantConfig = getSelectedVariantConfig();
      if (!variantConfig) return;

      // No checkbox on the page means no cable on offer here, so show the no-cable images.
      const wantCable = checkbox ? checkbox.checked : false;
      console.log('Rebuilding for:', variantConfig.filenamePart, wantCable ? '+ SYNC' : '(NO SYNC)');

      rebuildSwiper(swiper,    mainOriginalSlides, variantConfig, wantCable);
      rebuildSwiper(subSwiper, subOriginalSlides,  variantConfig, wantCable);
    }

    if (checkbox) {
      checkbox.addEventListener('change', updateGallery);
    } else {
      // Started without the checkbox: hook it up if the upsell app renders it late.
      let polls = 0;
      const lateCheckboxTimer = setInterval(() => {
        const found = findCableCheckbox();
        if (found) {
          clearInterval(lateCheckboxTimer);
          checkbox = found;
          checkbox.addEventListener('change', updateGallery);
          updateGallery();
        } else if (++polls >= LATE_CHECKBOX_POLLS) {
          clearInterval(lateCheckboxTimer);
        }
      }, 500);
    }

    if (config.variantFieldName) {
      const variantRadios = document.querySelectorAll('input[name="' + config.variantFieldName + '"]');
      variantRadios.forEach(radio => {
        radio.addEventListener('change', () => setTimeout(updateGallery, 100));
      });
    }

    updateGallery();

    console.log('Filename Switcher (rebuild mode) active for:', productHandle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageSwitcher);
  } else {
    initImageSwitcher();
  }

})();